import MetricBase from "models/metrics/MetricBase";
import VisibilityGroup from "models/groups/VisibilityGroup";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";

class MetricEligImprBing extends MetricBase {
    constructor() {
        super({
            field: "metric_elig_impr",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.bing-hotel-ads.eligImpr.chartName"),
            serieLabel: i18n.t("metrics.bing-hotel-ads.eligImpr.serieLabel"),
            tooltip: i18n.t("metrics.bing-hotel-ads.eligImpr.tooltip"),
            group: new VisibilityGroup(),
        });
    }
}

export default MetricEligImprBing;
